import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import styles from './ClientOverviewMetricCard.module.scss';

interface ClientOverviewMetricCardProps {
    label: string;
    value: string;
    pill?: string;
    danger?: boolean;
}

export const ClientOverviewMetricCard: FunctionComponent<ClientOverviewMetricCardProps> = props => {
    return (
        <div className={styles.card}>
            <p className={styles.cardLabel}>
                {props.label}
                {props.pill && <span className={styles.owesPill}>{props.pill}</span>}
            </p>
            <p className={clsx(styles.cardValue, { [styles.dangerValue]: props.danger })}>{props.value}</p>
        </div>
    );
};

export default ClientOverviewMetricCard;
